import { useRegisterSW } from 'virtual:pwa-register/react';

/** How often an open app checks for a new version. */
const CHECK_EVERY_MS = 60 * 60_000;

/**
 * Registers the service worker (the app opens without network) and offers
 * a new version when one is ready. Reloading is the person's choice, so an
 * update never interrupts a capture; saved data is on the device anyway.
 */
export function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) setInterval(() => void registration.update(), CHECK_EVERY_MS);
    },
  });
  if (!needRefresh) return null;
  return (
    <div className="update-banner" role="status">
      <span>A new version of the portal is ready.</span>
      <button
        type="button"
        className="btn primary sm"
        onClick={() => void updateServiceWorker(true)}
      >
        Reload
      </button>
    </div>
  );
}
